import React from "react";

import { type TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";

export const TotalBudgetHeaderContent = ({
  column,
  children,
}: TableHeaderRow.ContentProps) => {
  return (
    <>
      <div className="text-xs w-full flex justify-end items-center px-2">
        <span className="overflow-hidden min-w-[10px]">{children}</span>
      </div>
      <div className="header-column-separator"></div>
    </>
  );
};
